import { Injectable } from '@angular/core';
import { DataService } from 'src/app/core/data.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ContactUsService {

  constructor(private dataService: DataService) { }

  //Get method to get list of topics
  getTopicList(): Observable<any> {
    return this.dataService.getRequest('contactus/GetTopicsList');
  }

  //Post method to create contact us record
  postContactUsData(data: any) {
    return this.dataService.postRequest('contactus', data);
  }

  //Get method to validate uen number for validation+
  getEngagementByUEN(uenNumber: string) {
    return this.dataService.getRequest('preonboarding/CheckUENNumber/?UENNumber=' + uenNumber)
  }

  // API response to get the engagement details by id...
  public getCompanyNameList(userId: string, searchText:string): Observable<any> {
    return this.dataService.getRequest('User/GetEngagementDetailsByUserId?userId=' + userId + '&searchText='+ searchText);
  }
  // API response to get the creditor list by engagementid
  public getCreditorNameList(userId: string, engagementId: string): Observable<any> {
    return this.dataService.getRequest('User/GetCreditors?userId=' + userId + '&engagementId=' + engagementId + '&isContactUs=' + true);
  }
  //API response to get Terms and Conditions.
  public getTermsandConditions() {
    return this.dataService.getRequest('termsandconditions/GetTermsandConditions');
  }

  
  // API response to get the engagement details by id...
  public getUserDetails(userId: string): Observable<any> {
    return this.dataService.getRequest('User/GetUserProfileDetails?userId=' + userId);
  }

}
